import { ServiceCenter } from 'app/features/settings/models/service-center.model';

export interface ServiceCenterState {
  serviceCenters: ServiceCenter[];
  loading: boolean;
  error: string;
}

export const initialServiceCenterState: ServiceCenterState = {
  serviceCenters: [],
  loading: false,
  error: '',
};
